import { Button } from "@/components/ui/button";
import CountdownTimer from "@/components/CountdownTimer";
import { ArrowRight, Check, Zap } from "lucide-react";

const CHECKOUT_URL = "https://checkout.pagtrust.com.br/ck0b915526?funnel=fn7a46599f";

const offerFeatures = [
  "Acesso vitalicio a todos os 6 modulos",
  "Comunidade exclusiva de alunos",
  "Sessoes de mentoria em grupo",
  "Atualizacoes futuras incluidas",
  "Certificado de conclusao",
];

export default function OfferCard() {
  return (
    <section
      id="register"
      data-testid="register-section"
      className="py-24 md:py-32 lg:py-40 bg-black relative overflow-hidden"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#00FF00]/5 blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-12 text-center">
        <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#00FF00] mb-4">
          // Vagas limitadas
        </p>
        <h2 className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white mb-6">
          Comece sua <span className="text-[#00FF00]">transformacao</span>
        </h2>
        <p className="text-base md:text-lg text-white/50 mb-10 max-w-lg mx-auto">
          Inscricoes abertas ate 15 de abril de 2026. Garanta sua vaga e junte-se a proxima turma.
        </p>

        <div className="mb-12">
          <CountdownTimer targetDate="2026-04-15T23:59:59" />
        </div>

        <div
          data-testid="offer-card"
          className="max-w-md mx-auto border border-[#00FF00]/20 bg-[#0A0A0A] relative overflow-hidden"
        >
          <div className="bg-[#00FF00] py-2 px-4 flex items-center justify-center gap-2">
            <Zap size={14} className="text-black" />
            <span className="font-['JetBrains_Mono'] text-xs font-bold uppercase tracking-wider text-black">
              Oferta especial
            </span>
          </div>

          <div className="p-8 md:p-10">
            <div className="mb-8">
              <p className="font-['Manrope'] text-sm text-white/40 mb-1">Por apenas</p>
              <div className="flex items-baseline justify-center gap-1">
                <span className="font-['Outfit'] text-lg text-white/50">R$</span>
                <span data-testid="offer-price" className="font-['Outfit'] text-6xl md:text-7xl font-light tracking-tighter text-white">
                  29
                </span>
                <span className="font-['Outfit'] text-2xl text-white/70 self-start mt-3">,90</span>
              </div>
              <p className="font-['Manrope'] text-xs text-white/30 mt-2">Pagamento unico. Acesso vitalicio.</p>
            </div>

            <div className="w-full h-px bg-white/10 mb-8" />

            <ul className="space-y-4 mb-10 text-left">
              {offerFeatures.map((feature, i) => (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-[#00FF00]/10 flex items-center justify-center flex-shrink-0">
                    <Check size={12} className="text-[#00FF00]" />
                  </div>
                  <span className="font-['Manrope'] text-sm text-white/70">{feature}</span>
                </li>
              ))}
            </ul>

            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-testid="offer-checkout-link">
              <Button
                data-testid="offer-cta-button"
                className="w-full h-14 bg-[#00FF00] text-black font-semibold hover:bg-[#33FF33] rounded-none text-base tracking-wide shadow-[0_0_20px_rgba(0,255,0,0.2)] hover:shadow-[0_0_30px_rgba(0,255,0,0.4)] transition-all duration-300 animate-pulse-glow flex items-center justify-center gap-2"
              >
                QUERO MINHA VAGA
                <ArrowRight size={18} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
